import request from "@/utils/request";
import exp from "constants";



export const getReport = (params:{ type: string }) =>
    request({
        url: "/reports",
        method: "GET",
        params
    });

export const getReportOssUrl = (id:string) =>
    request({
        url: `/reports/ossUrls/${id}`,
        method: "GET",
    });

export const exportFinancial = (data: any) =>
    request({
        url: "/reports/financial",
        method: "PUT",
        data,
    });

export const exportCustomersProductInfos = (data: any) =>
    request({
        url: "/reports/customers-product-infos",
        method: "PUT",
        data,
    });

export const exportCostDetails = (data: any) =>
    request({
        url: "/reports/export-cost-details",
        method: "PUT",
        data
    })

export const exportDeclarationAmountDetailsFinances = (data: any) =>
    request({
        url: "/reports/export-declaration-amount-details-for-finances",
        method: "PUT",
        data
    })

export const exportHenganLoadingPlanTransship = (data: any) =>
    request({
        url: "/reports/hengan-loading-plan/transship",
        method: "PUT",
        data
    })


export const exportinventoryCommodityShipmentDetails = (data: any) =>
    request({
        url: "/reports/inventory-commodity-shipment-details",
        method: "PUT",
        data
    })


export const exportDeclarationAmountDetailsForLogistics = (data: any) =>
    request({
        url: "/reports/export-declaration-amount-details-for-logistics",
        method: "PUT",
        data
    })

export const exportDeclarationWorkLoadStatisticsExcel = (data: any) =>
    request({
        url: "/reports/export-declaration-work-load-statistics-excel",
        method: "PUT",
        data
    })

export const exportDeliveryNoteAndPackingList = (data: any) =>
    request({
        url: "/reports/delivery-note-packing-list",
        method: "PUT",
        data
    })

export const exportContainerTypeStatisticsExcel = (data: any) =>
    request({
        url: "/reports/container-type-statistics",
        method: "PUT",
        data
    })

export const customerShipmentStatistics = (data: any) =>
    request({
        url: "/reports/customer-shipment-statistics-report",
        method: "PUT",
        data
    })

export const exportWarehouseEntryFeeStatisticsReport = (data: any) =>
    request({
        url: "/reports/warehouse-entry-fee-statistics-report",
        method: "PUT",
        data
    })

export const productShipmentStatistics = (data: any) =>
    request({
        url: "/reports/product-shipment-statistics-report",
        method: "PUT",
        data
    })

export const exportDeclarationFee = (data: any) =>
    request({
        url: "/reports/export-declaration",
        method: "PUT",
        data
    })

export const exportBookingOrderStateReport = (data: any) =>
    request({
        url: "/reports/booking-order-state-report",
        method: "PUT",
        data
    })


export const factoryShipmentStatistics = (data: any) =>
    request({
        url: "/reports/factory-shipment-statistics",
        method: "PUT",
        data
    })


export const delayedShippingStatistics = (data: any) =>
    request({
        url: "/reports/delayed-shipping-statistics",
        method: "PUT",
        data
    })



export const createCustomerTransactionStatisticsReport = (data: any) =>
    request({
        url: "/reports/customer-transaction-statistics-report",
        method: "PUT",
        data
    })

export const createInStorageStatisticsOfPackingListStatisticsReport = () =>
    request({
        url: "/reports/in-storage-of-packing-list-report",
        method: "PUT",
    })

export const createPartDeliveryPackingListAmountStatisticsReport = () =>
    request({
      url: "/reports/part-delivery-packing-list-delivery-amount",
     method: "PUT",
    })
